/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterProtocol = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'experiments.protocol',
);

export const getPostFilteProtocol = (path?: string) =>
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    path ? path : 'protocol',
  );
